(ns story-builder.story-editor.animation-sidebar.sub
  (:require
   [re-frame.core :as rf]
   [story-builder.story-editor.animation-sidebar.util :as animation-sidebar.util]
   [story-builder.util.core :as util]))

(rf/reg-sub
 ::animation-sidebar
 (fn [db _]
   (:animation-sidebar db)))

(rf/reg-sub
 ::enabled-animations
 :<- [::animation-sidebar]
 (fn [db [_ animations]]
   (filterv #(get-in db [:animation-sidebar/animation-enabled? (:id %)] true)
            animations)))

(rf/reg-sub
 ::animation-enabled?
 :<- [::animation-sidebar]
 (fn [db [_ animation-id]]
   (get-in db [:animation-sidebar/animation-enabled? animation-id] true)))

(rf/reg-sub
 ::animations-enabled?
 (fn [_ _]
   [(rf/subscribe [::animation-sidebar])
    (rf/subscribe [:story/story-type])
    (rf/subscribe [:db-scenes])])
 (fn [[db story-type scenes] [_ layer-id]]
   (let [scene (util/find-first #(contains? (set (map :id (:layers %))) layer-id) scenes)]
     (and (not (and (= story-type "web")
                    (= (:type scene) "cover")))
          (:animation-sidebar/animations-enabled? db)))))

(rf/reg-sub
 ::animations-by-id
 :<- [:story/current-scene]
 (fn [current-scene _]
   (animation-sidebar.util/animations-by-id (:layers current-scene))))
